import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApiComponent} from './api.component';

@NgModule({
    declarations: [ApiComponent],
    exports: [
        ApiComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ApiModule { }
